import type { OpenDialogSegment } from './types';

const OPEN_DIALOG_MARKER = /\{\{\s*openDialog\(\s*id:\s*([^)]*?)\s*\)\s*:\s*([^}]*?)\s*\}\}/;

/**
 * Splits a sentence at its `{{ openDialog(id:<dialogId>): <label> }}` markers.
 * A marker without id or label is dropped; other `{{ … }}` placeholders stay plain text.
 */
export function parseOpenDialogMarkers(text: string): OpenDialogSegment[] {
  // A capturing split yields [text, id, label, text, id, label, …, text].
  const parts = text.split(OPEN_DIALOG_MARKER);
  const segments: OpenDialogSegment[] = [];

  for (let index = 0; index < parts.length; index += 3) {
    const plainText = parts[index];
    const dialogId = parts[index + 1];
    const label = parts[index + 2];

    if (plainText) {
      segments.push({ text: plainText });
    }

    if (dialogId && label) {
      segments.push({ text: label, dialogId });
    }
  }

  return segments;
}
